
import React from 'react'
import { useTranslation } from 'react-i18next'
import videoSrc from '../images/IMG_9247.MP4'

export default function Assembly() {
  const { t } = useTranslation();
  return (
    <div className='container'>
      <div className='installation-page'>
        <div className='left'>
          <h1>{t('installation.title')}</h1>
          <p className='intro'>{t('installation.intro')}</p>

          <div className='section'>
            <h2>{t('installation.proTitle')}</h2>
            <p>{t('installation.proDesc')}</p>
            <ul>
              <li>{t('installation.proPoint1')}</li>
              <li>{t('installation.proPoint2')}</li>
              <li>{t('installation.proPoint3')}</li>
            </ul>
          </div>

          <div className='section'>
            <h2>{t('installation.diyTitle')}</h2>
            <p>{t('installation.diyDesc')}</p>
            <ul>
              <li>{t('installation.diyPoint1')}</li>
              <li>{t('installation.diyPoint2')}</li>
              <li>{t('installation.diyPoint3')}</li>
            </ul>
          </div>

          <div className='section'>
            <h2>{t('installation.easyTitle')}</h2>
            <p>{t('installation.easyDesc')}</p>
          </div>
        </div>

        <div className='right'>
          <div className='video-wrapper' aria-label={t('installation.videoTitle')}>
            <video autoPlay muted controls playsInline width="100%">
              <source src={videoSrc} type="video/mp4" />
              {t('installation.videoFallback', 'Your browser does not support the video tag.')}
            </video>
          </div>
        </div>
      </div>
    </div>
  )
}
